<!-- 个人消息 -->
<template>
  <div class="personal-message">
    <div class="personal-message-con">
      <h1>All messages</h1>
      <!-- 只有em可以有 -->
      <!-- <img :src="setBlack"
           alt=""
           v-if="userRole==='EM'"
           @click="setHandle"
           class="message-setting"> -->
      <Form ref="formValidate"
            :model="formValidate">
        <div class="personal-message-sel">
          <FormItem label="Type"
                    prop="city">
            <Select v-model="formValidate.type"
                    placeholder="Select"
                    clearable>
              <Option v-for="(item, index) in messageTypeMap"
                      :key="index"
                      :value="item.value">{{item.title}}</Option>
            </Select>
          </FormItem>
        </div>
        <div class="personal-message-sel">
          <FormItem label="Date"
                    prop="city">
            <DatePicker type="datetimerange"
                        placeholder="Select date"
                        format="yyyy-MM-dd"
                        @on-change="changeTime"></DatePicker>
          </FormItem>
        </div>
        <div class="personal-message-btn">
          <Button class="zlr-btn-default"
                  @click="handleSearch">Search</Button>
        </div>
        <div class="personal-message-tab-btn">
          <Button class="zlr-btn-default"
                  @click="handleAllRead">Mark all as read</Button>
        </div>
      </Form>
      <ul class="personal-message-list"
          v-if="list.length">
        <li v-for="(item, index) in list"
            :key="index">
          <div class="personal-message-list-left">
            <img :src="item.source === 'MENTEE'?item.headPortrait:msp"
                 alt="头像">
          </div>
          <div class="personal-message-list-right">
            <div class="personal-message-list-intro">
              <div> {{item.source === 'MENTEE'? item.menteeName: 'MSP'}}<span>-</span>
                <remind-link :data="item"></remind-link>
              </div>
              <a v-if="item.readStatus==='UN_READ'"
                 @click="handleRead(item)">Mark as read</a>
            </div>
            <p>{{item.messageContent}}</p>
            <div class="personal-message-list-time">
              {{item.createTime}}
            </div>
          </div>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
      <div class="personal-message-page"
           v-if="list.length">
        <Page :total="totalItems"
              :page-size="pageSize"
              :current="currentPage"
              @on-change="handlePageChange"></Page>
      </div>
    </div>
    <zlr-modal v-model="messageModal">
      <div class="message-modal">
        <h1>Message setting</h1>
        <p>Automatically mark the comment message under the program as read</p>
        <div class="message-modal-btn">
          <Button class="zlr-btn-primary">Yes</Button>
          <Button class="zlr-btn-default"
                  @click="messageModal= false">No</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// api
import { getMessagePage, subMessageRead, subMessageReadAll } from '@/api/message'
// images
import msp from '@/assets/msp.svg'
import setBlack from '@/assets/images/home/setting-black.svg'
// components
import ZlrModal from '_c/modal/modal'
import ZlrEmpty from '_c/empty/empty'
import RemindLink from '_c/remind/remind-link'
// mixins
import mixinsPage from '@/view/mixins/page'
// constant
import { messageTypeMap, setSuc } from '@/constant'
import { mapState } from 'vuex'
export default {
  name: 'personal-message',
  mixins: [mixinsPage],
  components: {
    ZlrModal,
    ZlrEmpty,
    RemindLink
  },
  data () {
    return {
      messageTypeMap,
      msp,
      setBlack,
      formValidate: {
        createTimeStart: '',
        createTimeEnd: ''
      },
      messageModal: false,
      list: []
    }
  },
  computed: {
    ...mapState({
      'userRole' (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    this.getPageList()
  },
  methods: {
    getPageList () {
      let data = {
        ...this.formValidate,
        currentPage: this.currentPage - 1,
        pageSize: this.pageSize
      }
      getMessagePage(data).then(res => {
        let page = res.data.page
        this.list = page.result
        this.totalItems = page.totalItems
      }).catch(() => {
        this.list = []
        this.totalItems = 0
        this.pageSize = 1
      })
    },
    changeTime (data) {
      this.formValidate.createTimeStart = data[0]
      this.formValidate.createTimeEnd = data[1]
    },
    // 标记为已读
    handleRead ({ msgId }) {
      subMessageRead({
        msgId
      }).then(() => {
        this.$Message.success(setSuc)
        this.getPageList()
      })
    },
    // 标记所有为已读
    handleAllRead () {
      subMessageReadAll({}).then(() => {
        this.$Message.success(setSuc)
        this.getPageList()
      })
    },
    setHandle () {
      this.messageModal = true
    }
  }
}
</script>
<style lang='less' scoped>
</style>
<style lang="less">
.personal-message {
  .ivu-picker-confirm-time {
    display: none;
  }
}
</style>
